import React from "react";

function useMutation(url, options) {

  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const mutationFn = React.useCallback(async () => {
    try {
      setError("");
      setIsLoading(true);
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.ok) {
        setIsLoading(false);
        return { data, isSuccess: true };
      } else {
        throw new Error(data.message ?? "Unknown error.");
      }
    } catch (e) {
      setError(e.message ?? "Unknown error.");
      setIsLoading(false);
      return { isSuccess: false };
    }
  }, [url, options]);
  
  return { isLoading, error, mutationFn };
}

export default useMutation;
